<!--
 * @Author: nzj
 * 审核确认
-->
<template>
  <div>
    <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('驳回')"
      custom-class="j-dialog"
      :close-on-click-modal="false"
      top="45px"
      :visible.sync="turnDownVisible"
      @close="close"
      width="800px">
      <div class="content">
        <span class="title">{{ $lang('正在进行驳回申请操作,请填写驳回原因') }}:</span>
        <el-input
          type="textarea"
          :placeholder="$lang('请输入驳回原因')"
          v-model="reason"
          maxlength="500"
          show-word-limit
          rows="5"
        >
        </el-input>
        <div class="dialog_footer">
          <el-button @click="close">{{ $lang('取消') }}</el-button>
          <el-button type="primary" :loading="loading" @click="sumbit">{{ $lang('提交') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
import { expressReject } from '@api/module/customer'
export default {
  name: 'TurnDownDialog',
  props: {
    turnDownVisible: {
      type: Boolean,
      default: false
    },
    selectList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      reason: '',
      loading: false
    }
  },
  methods: {
    async sumbit() {
      if (!this.reason) {
        return
      }
      const newArr = this.selectList.map((item) => item.waybillNo)
      const params = {
        waybillIds: newArr,
        reason: this.reason
      }
      const { code, data, msg } = await expressReject(params)
      if (code === RESPONSE_SUCCESS) {
        if (!data) {
          return this.$message.error(this.$lang('驳回失败'))
        }
        this.$emit('successFn')
        this.close()
      } else {
        this.$message.error(msg)
      }
    },
    close() {
      this.$emit('update:turnDownVisible', false)
      this.reason = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
}

.el-textarea {
  margin-top: 10px;
}

.dialog_footer {
  float: right;
  margin-top: 20px;
}
</style>
